import { render, staticRenderFns } from "./user-management.vue?vue&type=template&id=082ced31&scoped=true&"
import script from "./user-management.vue?vue&type=script&lang=js&"
export * from "./user-management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082ced31",
  null
  
)

export default component.exports